// extracted by mini-css-extract-plugin
export var fadeInOut = "_37-3";
export var icon = "_37-4";
export var savedIndicator = "_37-2";
export var savingIndicator = "_37-0";
export var spin = "_37-1";